import { registerProjectDataSection } from '@trimble/project-data-panel-ui/registry';
import type { JSX } from 'solid-js';
import { PointCloudsTree } from './pointclouds-tree/PointCloudsTree';

const unregister = registerProjectDataSection('pointClouds', {
  requiresData: true,
  render: (context): JSX.Element => (
    <PointCloudsTree
      pointClouds={context.data()}
      isNodeLoading={context.operations.isNodeLoading}
      isNodeVisible={context.operations.isNodeVisible}
      onVisibilityToggle={context.operations.onVisibilityToggle}
      onCancelVisibilityToggle={context.operations.onCancelVisibilityToggle}
      onFitToView={context.operations.onFitToView}
      onRenderingSettings={context.operations.onRenderingSettings}
      isNodeSelected={context.operations.isNodeSelected}
      onNodeSelect={context.operations.onNodeSelect}
      onShowOnly={context.operations.onShowOnly}
      multiSelect={context.config.multiSelect}
      defaultExpandIds={
        context.config.initiallyExpanded ? ['pointClouds'] : undefined
      }
    />
  ),
});

if (import.meta.hot) {
  import.meta.hot.dispose(unregister);
}
